import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';

export const getEblastFilters = (): IFilterConfigItem[] => ([
  {
    title: 'Date Sent',
    name: 'eblast_date_sent',
    type: FilterTypeEnum.date_range,
    category: FilterCategoryEnum.eblast_details,
  },
  {
    title: 'Is Recurring',
    name: 'eblast_is_recurring',
    type: FilterTypeEnum.switch,
    category: FilterCategoryEnum.eblast_details,
  },
  getShowArchiveFilterConfig(),
]).filter(Boolean) as IFilterConfigItem[];
